<template>
  <RealTimeClient v-if="isAuthenticated" />
  <div v-else class="home-container">
    <div class="content">
      <div class="logo-section">
        <img src="https://trainerday.com/wp-content/uploads/2023/09/td_white.svg" alt="TrainerDay Logo" class="logo">
      </div>
      
      <div v-if="loading" class="loading-section">
        <div class="spinner"></div>
        <p class="loading-text">Loading...</p>
      </div>
      
      <div v-else-if="!isAuthenticated" class="auth-section">
        <h2 class="welcome-title">Welcome to TrainerDay Live</h2>
        <p class="welcome-subtitle">Sign in to access your live training experience</p>
        <button @click="signIn" class="signin-button">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
            <polyline points="10,17 15,12 10,7"></polyline>
            <line x1="15" y1="12" x2="3" y2="12"></line>
          </svg>
          Sign In
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { getUserData } from '@/data'
  import RealTimeClient from '@/Client'

  export default {
    name: 'HomePage',
    components: { RealTimeClient },

    data() {
      return {
        userId: null,
        isProd: false,
        loading: true,
        isAuthenticated: false,
        userData: null
      }
    },
    async mounted() {
      const { APP_ENV } = process.env
      this.isProd = APP_ENV === 'production'
      
      // Check authentication
      try {
        const userData = await getUserData()
        if (userData && userData.userId) {
          this.isAuthenticated = true
          this.userData = userData
          this.userId = userData.userId
          return // the template shows the viewer
        }
      } catch (error) {
        // Silently handle authentication errors - don't log to console
        // This prevents 401 errors from appearing in console when not authenticated
      }
      
      this.loading = false
      
      // Track home page load with Clicky
      if (typeof clicky !== 'undefined') {
        clicky.log('home_page_load', 'Home Page Loaded')
      }
    },
    methods: {
      signIn() {
        window.location.href = 'https://trainerday.com/login?redirect=https://ride.trainerday.com'
      }
    }
  }
</script>

<style scoped>
.home-container {
  min-height: 100vh;
  background: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.content {
  text-align: center;
  color: white;
  max-width: 500px;
  padding: 40px;
}

.logo-section {
  margin-bottom: 40px;
}

.logo {
  width: 200px;
  height: auto;
}

.loading-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  font-size: 18px;
  margin: 0;
  opacity: 0.9;
}

.auth-section {
  animation: fadeIn 0.5s ease-in;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.welcome-title {
  font-size: 32px;
  font-weight: 600;
  margin: 0 0 16px 0;
  color: white;
}

.welcome-subtitle {
  font-size: 18px;
  margin: 0 0 32px 0;
  opacity: 0.9;
  line-height: 1.5;
}

.signin-button {
  background: #dc2626;
  color: white;
  border: none;
  padding: 16px 32px;
  font-size: 18px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.signin-button:hover {
  background: #b91c1c;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.signin-button:active {
  transform: translateY(0);
}

@media (max-width: 600px) {
  .content {
    padding: 20px;
  }
  
  .logo {
    width: 150px;
  }
  
  .welcome-title {
    font-size: 24px;
  }
  
  .welcome-subtitle {
    font-size: 16px;
  }
  
  .signin-button {
    padding: 14px 28px;
    font-size: 16px;
  }
}
</style>
